module.exports = __webpack_public_path__ + "static/media/CEL.39ac7b20.svg";